import React, {useMemo} from 'react';
import InfoPanelTitle from '../SubComponents/InfoPanelTitle/InfoPanelTitle';
import IconTextPair from '../SubComponents/IconTextPair/IconTextPair';
import {isArrayValid} from '../../../../../Assets/functions/functions';

const InfoPanel = ({titleIcon, title, titleExtraInfo, contentArr}) => {
  const isInfoPanelContentArrValid = useMemo(() => {
    return isArrayValid(contentArr);
  }, [contentArr]);

  return (
    <div className='info-panel-container'>
      {title && (
        <InfoPanelTitle
          titleIcon={titleIcon}
          title={title}
          titleExtraInfo={titleExtraInfo}
        />
      )}
      {isInfoPanelContentArrValid && (
        <div className='info-panel-content'>
          {contentArr.map((item, index) => (
            <IconTextPair
              key={index}
              icon={item?.icon}
              textTitle={item?.textTitle}
              text={item?.text}
              isTopIcon={item?.isTopIcon}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default InfoPanel;
